import type { Mutation } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import { UnderTitleMessageType } from '@/enums/messageEnum'

const mutations: { [actionType: string]: Mutation<State> } = {
  [actionTypes.SET_MESSAGE_TYPE]: (
    state: State,
    messageType: UnderTitleMessageType
  ): void => {
    state.messageType = messageType
  },

  [actionTypes.SET_PAGE_MESSAGES]: (state: State, messages: string[]): void => {
    state.pageMessages = [...messages]
  },

  [actionTypes.ADD_PAGE_MESSAGE]: (state: State, message: string): void => {
    state.pageMessages = [...state.pageMessages, message]
  },

  [actionTypes.DELETE_ONE_PAGE_MESSAGE]: (state: State, message: string): void => {
    state.pageMessages = state.pageMessages.filter((item) => item !== message)
  },

  [actionTypes.CLEAR_PAGE_MESSAGE]: (state: State): void => {
    state.pageMessages = []
  },

  [actionTypes.SET_BALLON_MESSAGE_LAST_TYPE]: (state: State, type: string): void => {
    state.ballonMessageLastType = type
  },
}

export default mutations
